import React, { useCallback, useMemo, useState } from 'react';

import { routes } from '@aline/routes';
import { matchPath, useLocation } from 'react-router-dom';
import { ChatPanel } from 'src/components/ai/chat';
import type { SelectedPlaybookRun } from 'src/components/ai/chat/chat-hooks/useSelectedPlaybookRun';
import { useGlobalDrawer } from 'src/layouts/GlobalRightDrawer';

/**
 * Chat inside the workflow side panel. Closing is local: a missing thread
 * resets or closes this panel, and Go home would leave the workflow.
 */
export function WorkflowChatPanel() {
  const location = useLocation();
  const { closeDrawer } = useGlobalDrawer();
  const [threadId, setThreadId] = useState<string | null>(null);
  const [selectedPlaybookRun, setSelectedPlaybookRun] = useState<SelectedPlaybookRun | null>(null);
  const workflowId = matchPath(routes.WorkflowDetail, location.pathname)?.params.workflowId;
  const visibleContext = useMemo(() => (workflowId ? { workflowId } : undefined), [workflowId]);
  const handleCreateNewChat = useCallback(() => setThreadId(null), []);
  const handleNavigateToThread = useCallback((id: string) => setThreadId(id), []);

  return (
    <ChatPanel
      hideFeatureCards={true}
      selectedPlaybookRun={selectedPlaybookRun}
      threadId={threadId}
      visibleContext={visibleContext}
      onClose={closeDrawer}
      onCreateNewChat={handleCreateNewChat}
      onNavigateToThread={handleNavigateToThread}
      onSelectedPlaybookRunChange={setSelectedPlaybookRun}
    />
  );
}
